import { http } from "./api-config";

const apiClient = http(process.env.VUE_APP_TRANSCRIPTION_SERVICE);

export default {
  async createDocument(data) {
    const headers = { "Content-Type": "multipart/form-data" };
    const res = await apiClient.post("uploadmedia", data, {
      headers,
    });
    return res.data;
  },

  async deleteTranscription(meetingId) {
    const res = await apiClient.delete(`delete_transcription/${meetingId}`);
    return res.data;
  },
  async resetTranscription(resetData) {
    const res = await apiClient.put(`reset_transcription`, resetData);
    return res.data;
  },
  async uploadChunkFile(data) {
    const headers = { "Content-Type": "multipart/form-data", "isSilentAPI": true };
    const res = await apiClient.post("chunk-upload", data, {
      headers,
    });
    return res.data;
  },
};
